import { render } from "./EventCard.vue?vue&type=template&id=3a17c28a&scoped=true"
import script from "./EventCard.vue?vue&type=script&lang=js"
export * from "./EventCard.vue?vue&type=script&lang=js"

import "./EventCard.vue?vue&type=style&index=0&id=3a17c28a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\grntm\\OneDrive\\Study\\Vue Mastery\\real-world-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a17c28a"]])

export default __exports__